import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import request from '@/utils/request';
import util from '@/utils/util'
import header from '@/layouts/header.vue';
import footer from '@/layouts/footer.vue';
import noData from '@/components/noData.vue';
import globalTooltip from '@/components/globalTooltip.vue';
import tooltipDirective from '@/directives/tooltip';
import ICountUp from 'vue-countup-v2';
import {
	exportExcel
} from '@/utils/download.js'
import publicBack from '@/components/publicBack.vue';
import EnumRadio from '@/components/EnumRadio.vue';
import EnumSelect from '@/components/EnumSelect.vue';

import QRCode from 'qrcode.vue'

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';

import MarkdownIt from 'markdown-it';
import mathjax3 from 'markdown-it-mathjax3';

Vue.component('header-component', header)
Vue.component('footer-component', footer)
Vue.component('noData', noData)
Vue.component('GlobalTooltip', globalTooltip);
Vue.component('ICountUp', ICountUp)
Vue.component('publicBack', publicBack)
Vue.component('EnumRadio', EnumRadio)
Vue.component('EnumSelect', EnumSelect)
Vue.component('qr-code', QRCode)

import loading from '@/utils/loading';
import alertPlugin from '@/utils/alert-plugin';
import messageBoxPlugin from '@/utils/messageBox';
import vMml2Chtml from '@/directives/mml2chtml';

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(ElementUI);
Vue.use(loading);
Vue.use(alertPlugin);
Vue.use(messageBoxPlugin);
Vue.use(VueAwesomeSwiper);

Vue.directive('tooltip-target', tooltipDirective);
Vue.directive('mml-2-chmtl', vMml2Chtml);

const openUrl = (url, type) => {
	if (type == 'replace') {
		topUp(0, 'instant').then(() => {
			router.replace(url)
		})
	} else if (type == '_blank') {
		window.open(url, '_blank');
	} else {
		topUp(0, 'instant').then(() => {
			router.push(url)
		})
	}
}

const setLocalStorage = (name, any) => {
	localStorage.setItem(name, JSON.stringify(any))
}

const getLocalStorage = (name) => {
	return JSON.parse(localStorage.getItem(name))
}

Vue.component('el-input', {
	extends: ElementUI.Input,
	created() {
		this.$on('change', (value) => {
			this.$emit('input', value.trim())
		})
	}
})

const historyBack = (num = -1) => {
	if (num > 0) {
		num = -num;
	}
	window.history.go(num);
}

const topUp = (num = 0, type = 'smooth') => {
	return new Promise(resolve => {
		const container = document.querySelector('.mainOverflowY');

		if (!container) {
			console.error('Container not found!');
			resolve();
			return;
		}

		if (container.scrollTop <= num) {
			resolve();
			return;
		}

		container.scrollTo({
			top: num,
			behavior: type
		});


		const onScroll = () => {
			if (Math.abs(container.scrollTop) < (num + 1)) {
				container.removeEventListener('scroll', onScroll);
				resolve();
			}
		};

		container.addEventListener('scroll', onScroll);
	});
};

const md = new MarkdownIt({
	html: true,
	linkify: true,
	typographer: true,
});

md.use(mathjax3);

const markdownEscape = (str) => {
	return str ? md.render(str) : str
}

util.initBaseUrl(process.env.VUE_APP_API_URL);

Vue.prototype.$store = store;
Vue.prototype.$openUrl = openUrl;
Vue.prototype.$setLocalStorage = setLocalStorage;
Vue.prototype.$getLocalStorage = getLocalStorage;
Vue.prototype.$request = request;
Vue.prototype.$util = util
Vue.prototype.$rootUrl = process.env.VUE_APP_API_URL
Vue.prototype.$appUrl = process.env.VUE_APP_URL
Vue.prototype.$historyBack = historyBack
Vue.prototype.$topUp = topUp
Vue.prototype.$markdownEscape = markdownEscape
Vue.prototype.$exportExcel = exportExcel

// --- Dedicated AI Visualization LaTeX Engine (KaTeX) ---
import katex from 'katex';
import 'katex/dist/katex.min.css';

const renderLatex = (text) => {
	if (!text) return '';
	let str = String(text)
		.replace(/Σ/g, '\\sum ')
		.replace(/Δ/g, '\\Delta ')
		.replace(/½/g, ' \\frac{1}{2} ')
		.replace(/π/g, '\\pi ')
		.replace(/·/g, '\\cdot ')
		.replace(/₁/g, '_1').replace(/₂/g, '_2')
		.replace(/²/g, '^2').replace(/³/g, '^3')
		.replace(/∞/g, '\\infty ');

	// NORMALIZATION for AI Modules: Standardize parentheses usage
	str = str.replace(/\\frac\((\d+)\)\((\d+)\)/g, '\\frac{$1}{$2}')
		.replace(/\\frac\((.*?)\)\((.*?)\)/g, '\\frac{$1}{$2}')
		.replace(/\\sqrt\((.*?)\)/g, '\\sqrt{$1}')
		.replace(/\\text\((.*?)\)/g, '\\text{$1}');

	// Case 1: Standard Mixed text with $ delimiters (Standard AI format)
	if (str.includes('$')) {
		const parts = str.split(/(\$[^$]+\$)/);
		return parts.map(part => {
			if (part.startsWith('$') && part.endsWith('$')) {
				try {
					return katex.renderToString(part.slice(1, -1), { throwOnError: false, displayMode: false });
				} catch (e) { return part; }
			}
			return part;
		}).join('');
	}

	// Case 2: Deep Mixed text without $ delimiters (Fallback for AI modules)
	const parts = str.split(/(\\[a-zA-Z]+(?:(?:\{[^{}]*\}|\([^\)]*\))|(?:\s+[a-zA-Z0-9_\(\)\{\}]+))*|[\^_](?:\{[^{}]*\}|[a-zA-Z0-9]+))/);
	if (parts.length > 1) {
		return parts.map(part => {
			if (!part) return '';
			if (part.startsWith('\\') || part.startsWith('^') || part.startsWith('_')) {
				try {
					return katex.renderToString(part, { throwOnError: false, displayMode: false });
				} catch (e) { return part; }
			}
			return part;
		}).join('');
	}

	return str;
};

// --- Secure v-latex Directive for AI Modules ---

Vue.directive('latex', {
	bind(el, binding) {
		const apply = () => {
			if (binding.value === undefined && el._origSrc === undefined) {
				el._origSrc = el.innerText;
			}
			const val = (binding.value !== undefined) ? String(binding.value) : el._origSrc;
			if (el._lastRes === val) return;
			el._lastRes = val;
			el.innerHTML = renderLatex(val);
		};
		apply();
		el._applyLat = apply;
	},
	update(el, binding) {
		if (binding.value !== undefined) {
			const val = String(binding.value);
			if (val !== el._lastRes) { if (el._applyLat) el._applyLat(); }
		}
	}
});

// CRITICAL: DO NOT OVERRIDE v-mml-2-chmtl in main.js. 
// Use the original imported vMml2Chtml for Question Bank compatibility.

Vue.directive('observe', {
	inserted(el, binding) {
		const options = { threshold: 0.1 }
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					el.classList.add('fade-up-show')
					observer.unobserve(el)
				}
			})
		}, options)
		observer.observe(el)
	}
})

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')